module.exports = __webpack_public_path__ + "assets-cabinet/img/close-icon.3a9cb541.svg";